import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import css from './icon-message.scss';

/**
 * IconMessage pro-forma template for stateless component
 * Displays icon in grey circle with message underneath
 */
const IconMessage = ({ iconSrc, message }) => (
    <div className={css.component}>
        <div className={css['icon-container']}>
            <Isvg src={iconSrc} cacheGetRequests />
        </div>
        <p>{message}</p>
    </div>
);

IconMessage.propTypes = {
    iconSrc: PropTypes.string,
    message: PropTypes.string
};

export default styleable(css)(IconMessage);



// WEBPACK FOOTER //
// ./components/icon-message/icon-message.js